import { BADGE_APIS } from "libs/apis/badge.api";
import { useNavigate } from "react-router-dom";
import { successToaster } from "utils/helpers/common/alert-service";
import { BadgeDTO } from "utils/helpers/models/badge/badge.dto";

const useBadges = () => {
  const navigate = useNavigate();
  const createBadge = async (body: BadgeDTO) => {
    const response = await BADGE_APIS.createBadge(body);
    const { status = false } = response || {};
    if (status) {
      navigate(-1);
    }
  };

  const getBadges = async (
    setData: Function,
    queryParams: any = {},
    setFilters?: Function,
    setTotalElements?: Function
  ) => {
    const response = await BADGE_APIS.getBadges(queryParams);
    const { status = false, data = null } = response || {};
    if (status && data) {
      const {
        content = [],
        pageNumber = 0,
        pageSize = 10,
        totalElements = 0,
      } = data;
      setData(content);
      setFilters((prev) => ({
        ...prev,
        page: Number(pageNumber) + 1,
        limit: pageSize,
      }));
      setTotalElements?.(totalElements);
    }
  };

  const toggleStatus = async (userId: number) => {
    const response = await BADGE_APIS.toggleStatus(userId);
    const { status = false, message = "" } = response || {};
    if (status) {
      successToaster(message);
    }
  };

  const getAllCoreConcept = async (
    setData: Function,
    queryParams: any = {}
  ) => {
    const response = await BADGE_APIS.getAllCoreConcept(queryParams);
    const { status = false, message = "", data = null } = response || {};
    if (status && data) {
      const { content = [] } = data;
      setData(content);
      // successToaster(message);
    }
  };

  const createCoreConceptBadge = async (body: BadgeDTO) => {
    const response = await BADGE_APIS.createBadge(body);
    const { status = false } = response || {};
    if (status) {
      return response;
    }
  };

  const updateCoreConcept = async (id: number, queryParams: any = {}) => {
    const response = await BADGE_APIS.updateCoreConcept(id, queryParams);
    const { status = false } = response || {};
    if (status) {
      navigate(-1);
    }
  };

  return {
    createBadge,
    getBadges,
    toggleStatus,
    getAllCoreConcept,
    updateCoreConcept,
    createCoreConceptBadge,
  };
};

export default useBadges;
